import {createSlatePlugin} from "platejs";
import {preserveAttributes} from "./base-plate-plugins";

export const IframePlugin = createSlatePlugin( {
    key: "iframe",
    node: {
        isElement: true,
    },
    parsers: {
        html: {
            deserializer: {
                rules: [{
                    validNodeName: "IFRAME"
                }],
                attributes: preserveAttributes,
            }
        }
    }
})
